import React from 'react';
import { useScrollTo } from '@jokerdad/hooks';
import { FaArrowUp } from 'react-icons/fa';

var BackToTopButton = function BackToTopButton() {
  var backToTop = useScrollTo();
  return /*#__PURE__*/React.createElement("button", {
    className: "w-[7rem] h-[7rem] flex items-center justify-center absolute bottom-6 right-6 mt-8 bg-primary rounded-full",
    onClick: backToTop
  }, /*#__PURE__*/React.createElement(FaArrowUp, {
    className: "text-white text-6xl"
  }));
};

export default BackToTopButton;